module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-04.c6249092.png";